import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, Table, Button } from "react-bootstrap";
import moment from "moment";
import { formatMoney } from "accounting";
import TransactionFormModal from "../Transactions/TransactionFormModal";

class TransactionsTab extends Component {
  render() {
    const { transactions, organizationName } = this.props;

    return (
      <div>
        <div className="d-flex justify-content-center mb-2">
          {
            this.props.action === "edit" &&
            <Button
              variant="link"
              onClick={() => {
                this.props.newTransaction();
              }}>
              Create Transaction
            </Button>
          }
        </div>
        <TransactionFormModal />
        <Table responsive>
          <thead>
            <tr>
              <th>Date</th>
              <th>Description</th>
              <th>Created By</th>
              <th>Amount</th>
              <th>Balance</th>
              <th>Signature</th>
              <th></th>
            </tr>
          </thead>
          <tbody className="transactions">
            {
              transactions.map((transaction) => {
                return (
                  <tr key={transaction.id}>
                    <td>{moment(transaction.created_at).format("MM/DD/YYYY")}</td>
                    <td>{transaction.description}</td>
                    <td>{transaction.user?.name}</td>
                    <td>{formatMoney(transaction.amount)}</td>
                    <td>{formatMoney(transaction.balance)}</td>
                    <td>
                      {
                        transaction.resident_signature_url !== "/resident_signatures/original/missing.png" &&
                        <img src={transaction.resident_signature_url} />
                      }
                    </td>
                    <td>
                      <a href={`/organizations/${organizationName}/transactions/${transaction.id}/edit`}>Edit</a>
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    transactions: state.transactions,
    organizationName: state.organization.name,
    action: state.ui.action
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    newTransaction: () => {
      dispatch({
        type: "NEW_RESOURCE",
        payload: { resourceName: "transaction" }
      })
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TransactionsTab);
